import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// Native Android/iOS builds load the app from an internal WebView origin
// (e.g. https://localhost) that has no backend behind it, so a relative
// '/api' path resolves to nothing. Point native builds at the real backend;
// web builds (local dev via Vite proxy, or served by Nginx on AWS) keep
// using the relative path, which already resolves correctly there.
// Production target. For local-dev testing against a backend on your own
// machine (mvn spring-boot:run, port 8080), temporarily swap this for
// 'http://10.0.2.2:8080/api' (10.0.2.2 is the Android emulator's alias for
// the host machine's localhost) and re-enable the matching cleartext
// exception in android/app/src/main/res/xml/network_security_config.xml —
// revert both before shipping a build.
const NATIVE_API_BASE_URL = 'https://stockxignal.com/api';

const baseURL = Capacitor.isNativePlatform() ? NATIVE_API_BASE_URL : '/api';

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

/** Coerces an API response body into an array. Every list endpoint in this
 *  app is normally read as `res.data || []`, but that guard only protects
 *  against null/undefined — a non-array truthy body (an error JSON object
 *  like {status, error, message} on a request that resolves instead of
 *  rejecting, or any unexpected shape) sails through and crashes the first
 *  `.map()`/spread on it with "x.map is not a function". Use this instead
 *  wherever a response is expected to be a list. */
export const asArray = (v) => (Array.isArray(v) ? v : []);

export default api;
